import * as React from 'react';
// MUIのタブコンポーネントをインポート
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// ユーザーチャットコンポーネントをインポート
import UserChat from '../organisms/UserChat';

// タブパネルのプロパティ型定義
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

// タブパネルのコンポーネント
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

// アクセシビリティ用のプロパティを生成
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

/** user 資料ページ サブメニュー */
const UMSubMenu = () => {
  // 現在選択されているタブの状態を管理
  const [value, setValue] = React.useState(0);

  // タブが変更されたときの処理
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/* タブのヘッダー */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="　概要　" {...a11yProps(0)} />
          <Tab label="チャット" {...a11yProps(1)} />
          <Tab label="お知らせ" {...a11yProps(2)} />
        </Tabs>
      </Box>
      {/* 各タブのコンテンツ */}
      <CustomTabPanel value={value} index={0}>
        <Box height='120px'>概要を表示</Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Box height='340px'>
          <UserChat height={260}/>
        </Box>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Box height='120px'>お知らせを表示</Box>
      </CustomTabPanel>
    </Box>
  );
}

export default UMSubMenu;